import { faTrophy } from "@fortawesome/free-solid-svg-icons";

import Collaborators from "../../components/Collaborators";
import ContainerDivider from "../../components/ContainerDivider";
import Footer from "../../components/Footer";
import Icon from "../../components/Icon";
import Navbar from "../../components/Navbar";
import React, { useEffect, useState } from "react";
import Spacer from "../../components/Spacer";
import SubscriptionSection from "../../components/SubscriptionSection";
import useAwards from "../../hooks/useAwards";
import useEvent from "../../hooks/useEvent";
import AwardsGroup from "../../components/AwardsGroup";
import ComingSoon from "../../components/ComingSoon";
import Spinner from "../../components/Spinner";
import Container from "../../components/Container";
import { groupBy, uniq } from "lodash";

const Awards = () => {
  const event = useEvent();
  const awards = useAwards();
  const [isLoading, setIsLoading] = useState(true);

  const types =
    awards && uniq(awards.map((award: { type: string }) => award.type));
  const awardsGroups = groupBy(awards, "type");

  // Remove loading flag
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="AwardsPage">
      <Navbar />

      {isLoading ? (
        <Container>
          <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
            <div className="flex items-center justify-center space-x-4">
              <span>
                <Spinner />
              </span>{" "}
              <span>Loading...</span>
            </div>
          </div>
        </Container>
      ) : !awards || !awards.length ? (
        <ComingSoon pageName="Awards" />
      ) : (
        <div className="w-full">
          {types.map((type: any, key: string) => (
            <AwardsGroup
              title={type}
              subtitle={
                event === "SEAADE"
                  ? "November 24-25, 2020"
                  : event === "IADR"
                  ? "November 26-27, 2020"
                  : ""
              }
              awards={awardsGroups[type].map((award: any) => {
                return {
                  header: (
                    <div className="space-y-2">
                      <div className="text-aqua">
                        <Icon icon={faTrophy} /> {award.category}
                      </div>
                    </div>
                  ),
                  title: `${award.firstname} ${award.lastname}`,
                  subtitle: `${award.abstractNo} - ${award.title}`,
                  institute: award.institute,
                  src: award.src,
                };
              })}
              key={key}
            />
          ))}
        </div>
      )}

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Awards;
